<mat-card class="settingsBody">
    <span class="settings-heading">Branch Projections</span>

    <div>
        <br />
        To change when you would like to allow branch managers to be able to enter projections, you
        may change the opening and closing dates below.
    </div>
    <div>
        <form [formGroup]="projectionsDateForm" (ngSubmit)="onSubmit()" novalidate>
            <div>
                <table style="margin: 0px 0px 24px 0px">
                    <tr>
                        <td class="date-label">
                            <div class="input-label">{{ currentYear }} Opening Date</div>
                            <kendo-datepicker
                                class="date-input"
                                formControlName="currentYearOpenDate"
                                format="MM/dd/yyyy"
                                required
                            ></kendo-datepicker>
                        </td>
                        <td class="date-label">
                            <div class="input-label">{{ currentYear }} Closing Date:</div>
                            <kendo-datepicker
                                class="date-input"
                                format="MM/dd/yyyy"
                                formControlName="currentYearClosingDate"
                                required
                            ></kendo-datepicker>
                        </td>
                    </tr>
                    <tr
                        class="errors"
                        *ngIf="
                            (currentYearOpenDate.errors && currentYearOpenDate.touched) ||
                            (currentYearClosingDate.errors && currentYearClosingDate.touched)
                        "
                    >
                        <td class="error-cell" colspan="2">
                            <span
                                *ngIf="
                                    currentYearOpenDate.errors.required &&
                                    currentYearOpenDate.touched
                                "
                            >
                                * Required
                            </span>
                        </td>
                        <td class="error-cell" colspan="2">
                            <span
                                *ngIf="
                                    currentYearClosingDate.errors.required &&
                                    currentYearClosingDate.touched
                                "
                            >
                                * Required
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td class="date-label">
                            <div class="input-label">{{ currentYear + 1 }} Opening Date:</div>
                            <kendo-datepicker
                                class="date-input"
                                format="MM/dd/yyyy"
                                formControlName="nextYearOpenDate"
                                required
                            ></kendo-datepicker>
                        </td>
                        <td class="date-label">
                            <div class="input-label">{{ currentYear + 1 }} Closing Date:</div>
                            <kendo-datepicker
                                class="date-input"
                                format="MM/dd/yyyy"
                                formControlName="nextYearClosingDate"
                                required
                            ></kendo-datepicker>
                        </td>
                    </tr>
                </table>
            </div>
            <div>
                <button
                    mat-raised-button
                    class="button"
                    [disabled]="!projectionsDateForm.dirty || !projectionsDateForm.valid"
                    type="submit"
                >
                    SAVE CHANGES
                    <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
                </button>
            </div>
        </form>
    </div>
</mat-card>
